import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { PageHeaderComponent } from '../../../components/shared/page-header/page-header.component';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { TagModule } from 'primeng/tag';
import { MenuModule } from 'primeng/menu';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { DrawerModule } from 'primeng/drawer';
import { TabsModule } from 'primeng/tabs';
import { Router } from '@angular/router';
import { CompanyService } from './company.service';
import { RefParamsService } from '../ref-params/ref-params.service';
import { Company } from '@/types';
import { getCompanyDataTableStructure } from './utils/company-data-table-object';
import { DataTableRowActions, DynamicDataTable } from '../../../components/data-table-builder/data-table.types';
import { DataTableBuilderComponent } from '../../../components/data-table-builder/data-table-builder.component';
import { DialogObject } from '../../../components/dialog/dialog.types';
import { DialogComponent } from '../../../components/dialog/dialog.component';
import { CompanyRepository } from '../../../store/company-state/company-state.repository';
import { MessageService } from 'primeng/api';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'sm-company',
  imports: [
    PageHeaderComponent,
    CommonModule,
    ButtonModule,
    TableModule,
    IconFieldModule,
    InputIconModule,
    TagModule,
    MenuModule,
    InputTextModule,
    FormsModule,
    SelectModule,
    DrawerModule,
    TabsModule,
    DataTableBuilderComponent,
    DialogComponent,
    TranslateModule,
  ],
  templateUrl: './company.component.html',
  styleUrl: './company.component.scss',
})
export class CompanyComponent implements OnInit {
  refParamsService = inject(RefParamsService);
  companyService = inject(CompanyService);
  companyRepository = inject(CompanyRepository);
  messageService = inject(MessageService);
  translate = inject(TranslateService);
  router = inject(Router);

  breadcrumb = [
    {
      label: 'settings.companyInfo.breadcrumb.parametres',
      routerLink: ['/settings'],
    },
    {
      label: 'settings.companyInfo.breadcrumb.companyInfo',
      routerLink: ['/settings', 'company'],
    },
  ];

  @ViewChild('dialog') dialogComponent!: DialogComponent;
  companyDialog?: DialogObject;

  rowActions: DataTableRowActions = {
    inspectAction: () => this.router.navigate(['/settings', 'company', 'inspect', this.companyRepository.getNested('response', 'id')]),
  };

  data: Company[] = [];

  dataTableObject: DynamicDataTable = getCompanyDataTableStructure({
    store: this.companyRepository,
    rowActions: this.rowActions,
  });
  loading = true;

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this.companyService.getApprovedCompanies().subscribe({
      next: data => {
        this.data = data.content;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Une erreur est survenue lors de la récupération de la société',
        });
      },
    });
  }
}
